<div >
    <div>
        <div style="background-color:#035FA0; color: white; height:3px; margin-top:5px; padding: 5px;">
            &nbsp;
        </div>
        
    </div>
</div> 